import { gql } from '@apollo/client';

export const GET_OPPOSITION_BASES_BY_BRANCH = gql`
query getOppositionBasesByBranch($branch: ID!) {
  getOppositionBasesByBranch(branch: $branch) {
    _id
    name
    description
    fileUrl
    active
    createdAt
  }
}
`;
